var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopShareOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m8 0 9 8.5L8 17v-4.904l-.175-.003c-.354.001-1.25.04-2.757.33C3.392 12.745.038 17 .038 17l-.02-.192a7.5 7.5 0 0 1 .024-1.327c.085-.82.315-1.884.589-2.957l.314-1.183C1.83 8.148 3.143 4.946 8 5zm6.086 8.499-4.084-3.857-.018 2.38L7.978 7c-2.672-.03-3.786.863-4.763 3.772l-.122.373.017-.01c.458-.296.902-.506 1.354-.625l.227-.051.628-.114c1.103-.186 1.948-.257 2.548-.252l.26.007 1.873.12-.001 2.139z"
})));
export default SvgFacebookDesktopShareOutlined;